import { Color, Flex, Icon, Space, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { getBankLineDescription } from '@features/bankTransactions/utils/getBankLineDescription'

import { useLocale } from '../../../../../../../../hooks/useLocale'
import { formatDate } from '../../../../../../../../utils'
import { useBankTransactionDrawer } from '../../../../contexts'
import { transactionTypeToIcon } from '../../../BankTransactionsList/constants/transactionTypeToIcon'
import { formatTransactionAmount } from '../../../BankTransactionsList/utils/formatTransactionAmount'
import { formatTransactionType } from '../../../BankTransactionsList/utils/formatTransactionType'
import * as Styled from './styles'

export const DrawerHeader = (): ReactElement | null => {
  const { t } = useTranslation()
  const { code } = useLocale()
  const { selectedTransaction, currency } = useBankTransactionDrawer()

  if (!selectedTransaction) {
    return null
  }

  const { description, amount, side, entryDate, type } = selectedTransaction

  const formattedAmount = formatTransactionAmount(amount, side)
  const formattedType = formatTransactionType(type, side)
  const icon = transactionTypeToIcon[formattedType]
  const formattedDate = formatDate(entryDate, 'd MMMM yyyy', code)

  return (
    <Styled.HeaderContainer>
      <Flex flexDirection="column" alignItems="center" gap={Spacing.S4}>
        <Flex alignItems="baseline" gap={Spacing.S8}>
          <Text variant="h1" weight="bold">
            {formattedAmount}
          </Text>
          {currency && <Text variant="h3">{currency}</Text>}
        </Flex>
        <Text variant="bodySM" weight="medium">
          {getBankLineDescription(description)}
        </Text>
      </Flex>

      <Space />

      <Styled.IconWrapper>
        <Icon icon={icon} color={Color.Grey950} size="lg" />
      </Styled.IconWrapper>

      <Space />

      <Flex justifyContent="space-between" width="100%">
        <Text colorVariant="discreet">{t('bank_transactions.drawer.date_label')}</Text>
        <Text colorVariant="discreet">{formattedDate}</Text>
      </Flex>
    </Styled.HeaderContainer>
  )
}
